import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const PLANTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PlantType.Name')
    .required()
    .minLength(3)
    .maxLength(100)
    .build(),
];

export const PLANTTYPE_CONFIG = {
  entityName: 'PlantType',
  localizationKey: 'General::Entity.PlantType',
  fields: PLANTTYPE_FIELDS,
  permission: 'GeneralConsumables.PlantTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
